/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 10:06:58
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-08 16:23:36
 */
const im = [
    {
        path: "/im/:id",
        name: "im",
        component: () => import("../views/im/index.vue")
    },
    {
        path: "/oldim/:id",
        name: "oldim",
        component: () => import("../views/im/oldIm.vue")
    },
    {
        path: "/comment/:doctorId",
        name: "comment",
        component: () => import("../views/im/comment.vue")
    }
];
export default im;



// WEBPACK FOOTER //
// ./src/router/im.js